import type { VehicleMatch } from '@ltvco/refresh-lib/api';

export interface VehicleMatchWithDetails extends VehicleMatch {
  imageUrl: string | null;
}

export const VEHICLE_TYPES = [
  'Sedan',
  'SUV',
  'Truck',
  'Coupe',
  'Convertible',
  'Wagon',
  'Minivan',
  'Hatchback',
] as const;

export const USAGE_TYPES = [
  'Family',
  'Commuting',
  'Adventure',
  'Performance',
  'Luxury',
  'Work/Business',
] as const;

export type VehicleType = (typeof VEHICLE_TYPES)[number] | '';
export type UsageType = (typeof USAGE_TYPES)[number] | '';
export const NO_MATCHES_MESSAGE =
  "We couldn't find any vehicles that match your criteria. Try adjusting your budget or preferences.";
